import { render, staticRenderFns } from "./AddPhysiotherapist.vue?vue&type=template&id=bd2c756c"
import script from "./AddPhysiotherapist.vue?vue&type=script&lang=ts"
export * from "./AddPhysiotherapist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports